import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import GreyTick from '../../assets/greyTick.svg';
import GreenTick from '../../assets/greenTick.svg';
import './style.scss';
import { sum, words } from 'lodash';
import { verifyGroupExpression, getDescription } from '../../utils/utility'
function RegexValidationUI({ value, userDetails, updateGroup }) {
    const [groups, setGroups] = useState([]);
    const verifyRegex = (value) => {
        groups.map((group) => {
            group.rule.map((rule) => {
              if (value.match(rule.regex)) {
                rule.completed = 1;
              } else {
                rule.completed = 0;
              }
            });
            group.completed = verifyGroupExpression(group);
          });
          if (groups.length > 0){
              setGroups([...groups]);
              updateGroup([...groups]);
          } 
    }
    const parseRules = (data) => {
        const regexRules = data?.passwordValidationRules?.filter((rule) => rule.ruleType === 'REGEX');
        // setRules(regexRules);
        let expression = data.expression;
            let exps = expression?.split('&&') || [];
            setGroups(
            exps.map((exp) => {
                let tokens = words(exp, /[A-z](?:_?[A-z0-9]+)/g);
                let parseRule = regexRules.filter((bb) => exp.includes(bb.ruleId));
                let expParse = exp.replace(/[)()]/g, '');
                return {
                completed: false,
                exp: expParse,
                rule: parseRule,
                title:
                    tokens.length == 1
                    ? parseRule[0].description
                    : getDescription(expParse, tokens),
                expLength: tokens.length,
                };
            })
            );
      }
      useEffect(()=>{
        parseRules(userDetails);
    },[])
    useEffect(()=>{
        verifyRegex(value);
    },[value]);

    const GetTick = ({isGreen}) => {
        return  (
            <div className={`checkBox`}>
                {isGreen ? (<img src={GreenTick} />) : <img src={GreyTick} />}
            </div>
            )
    }
    return <div className="validationContainer">
         {value.length > 0 && <div className="passwordStrength"> Password Requirements:</div>}
        {value.length > 0 && groups?.map((group, i) => (
              <div className="regexValidationWrapper"  key={i}>
                {groups.length > 1 && (
                  <div className="titleWrapper">
                    <GetTick isGreen={group?.completed}/>
                    <div className={`title ${group?.completed ? 'isCompleted': ''}`}>{group.title}</div>
                  </div>
                )}
                <div className={`regexValidationContainer ${group.rule.length > 1 ? 'isMultipleGroup': ''}`}>
                  {group.rule?.map(
                    (rule) =>
                      group.expLength > 1 && (
                        <div className="rule" key={rule.ruleId}>
                            <GetTick isGreen={rule?.completed === 1}/>
                          <span className={`description ${rule?.completed === 1 ? 'isCompleted': ''}`}>
                            {rule?.description}
                          </span>
                        </div>
                      )
                  )}
                </div>
              </div>
            ))}</div>
}
RegexValidationUI.propTypes = {
    value: PropTypes.string,
    userDetails: PropTypes.any
}
export default RegexValidationUI;